import React from 'react';

const PurposeIcon = () => (
  <svg
    width={80}
    height={80}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1633_1328)">
      <path
        d="M15.0979 20.9996C14.9465 20.9996 14.8226 20.8727 14.8226 20.7177C14.8226 17.9219 12.5691 15.4677 10.0004 15.4677C7.43176 15.4677 5.17826 17.6823 5.17826 20.4044C5.17826 20.5595 5.05434 20.6863 4.90288 20.6863C4.75142 20.6863 4.6275 20.5595 4.6275 20.4044C4.6275 17.3706 7.03858 14.9038 10.0004 14.9038C12.9622 14.9038 15.3733 17.5664 15.3733 20.7177C15.3733 20.8727 15.2494 20.9996 15.0979 20.9996Z"
        fill="#0A3887"
      />
      <path
        d="M9.99934 14.0081C7.66323 14.0081 5.7616 12.0628 5.7616 9.66961C5.7616 7.27641 7.6617 5.33115 9.99934 5.33115C12.337 5.33115 14.2371 7.27641 14.2371 9.66961C14.2371 12.0628 12.337 14.0081 9.99934 14.0081ZM9.99934 5.89656C7.96614 5.89656 6.31235 7.58966 6.31235 9.67117C6.31235 11.7527 7.96614 13.4458 9.99934 13.4458C12.0325 13.4458 13.6863 11.7527 13.6863 9.67117C13.6863 7.58966 12.0325 5.89656 9.99934 5.89656Z"
        fill="#0A3887"
      />
      <path
        d="M19.5361 18.2385H0.461705C0.310248 18.2385 0.1695 18.1633 0.0822969 18.0365C-0.00490572 17.9096 -0.024794 17.7467 0.0272216 17.6026L5.01919 3.74621H2.97528C2.74886 3.74621 2.56222 3.58802 2.52091 3.36092C2.4796 3.13381 2.5974 2.91611 2.807 2.8331L9.83216 0.032681C9.94078 -0.0111734 10.0586 -0.0111734 10.1672 0.032681L17.1908 2.83153C17.402 2.91611 17.5198 3.13225 17.4769 3.35935C17.4341 3.58645 17.249 3.74464 17.0226 3.74464H14.9786L19.9706 17.6011C20.0226 17.7467 20.0027 17.9081 19.9155 18.0349C19.8299 18.1618 19.6876 18.237 19.5361 18.237V18.2385ZM0.588684 17.6747H19.4092L14.4187 3.81826C14.3667 3.6726 14.3866 3.51128 14.4738 3.38441C14.561 3.25755 14.7017 3.18237 14.8532 3.18237H16.5529L9.99892 0.569898L3.44648 3.18237H5.14617C5.29763 3.18237 5.4399 3.25755 5.52558 3.38441C5.61125 3.51128 5.63267 3.67416 5.58065 3.81826L0.588684 17.6747Z"
        fill="#0A3887"
      />
    </g>
    <defs>
      <clipPath id="clip0_1633_1328">
        <rect width={20} height={21} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PurposeIcon;
